<template>
  <div class="Financial_box">
    <div class="title">{{userinfo.unit_name}}的人员情况 ({{ year }}年度)</div>
    <div>
      <el-descriptions :column="4" border>
        <el-descriptions-item
          v-for="(item, index) in list"
          :key="index"
          :label-class-name="'labelclass' + item.level"
          content-class-name="my-content"
          :span="item.span || 2"
        >
          <template slot="label">
            <span style="color: #e60013" v-if="item.show">*</span>
            {{ item.label }}
          </template>
          <div :class="getClassName(item.check)">
            <el-input-number
              :controls="false"
              :min="0"
              v-model="item.value"
              @blur="check(item, index)"
              :placeholder="item.placeholder ? item.placeholder : '请输入人数'"
              :disabled="item.disabled"
            >
            </el-input-number>

            <span
              class="checkname"
              v-if="item.checkname && item.checkname != ''"
              >{{ item.checkname }}</span
            >
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="button_box" v-if="!bc">
        <el-button
          type="primary"
          @click="Submit"
          :loading="loading"
          :disabled="bc"
          >保 存</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import upload from "@/components/upload.vue";
export default {
  components: {
    upload: upload,
  },
  data() {
    return {
      userinfo:JSON.parse(localStorage.getItem("info")),

      loading: false, //节流
      timerId: null,
      bc: false,
      year: "",
      info: {},
      list: [
        {
          value: undefined, //定义的值
          label: "一、期末企业人员合计(人)：", //显示的名称
          name: "qm_total", //后台变量
          level: "a", //标题等级
          placeholder: "根据以下填写数据自动计算", //默认提示
          disabled: true, //是否禁用
          show: false, //是否开启校验
          check: false, //校验提示类添加
          // checkname: '',//规则展示
          span: 4,
          id: 1, //自身表示用于计算
          count: [2, 3], //计算的变量
          counttype: "+", //计算的类型 + -
        },
        {
          value: undefined,
          label: "1.招标代理专职人员(人)",
          name: "zb_people",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 2,
          span: 2,
        },
        {
          value: undefined,
          label: "2.其他人员(人)",
          name: "other_people",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 3,
          span: 2,
        },
        {
          value: undefined,
          label: "二、期末企业人员中专业技术人员合计(人)：",
          placeholder: "根据以下填写数据自动计算", //默认提示
          name: "qm_js_total",
          level: "a",
          disabled: true,
          show: false,
          check: false,
          id: 4,
          span: 4,
          count: [5, 6, 7, 8], //计算的变量
          counttype: "+", //计算的类型 + -
        },
        {
          value: undefined,
          label: "1.高级职称人员(人)",
          name: "js_heigh",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 5,
          span: 2,
        },
        {
          value: undefined,
          label: "2.中级职称人员(人)",
          name: "js_middle",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 6,
          span: 2,
        },
        {
          value: undefined,
          label: "3.初级职称人员(人)",
          name: "js_primary",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 7,
          span: 2,
        },
        {
          value: undefined,
          label: "4.其他人员(人)",
          name: "js_other",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 8,
          span: 2,
        },
        {
          value: undefined,
          label: "三、期末企业人员中注册执业人员合计(人)：",
          placeholder: "根据以下填写数据自动计算", //默认提示
          name: "qm_zc_total",
          level: "a",
          disabled: true,
          show: false,
          check: false,
          id: 9,
          span: 4,
          count: [10, 13, 16, 17, 20, 21], //计算的变量
          counttype: "+", //计算的类型 + -
        },
        {
          value: undefined,
          label: "1.注册造价工程师(人)",
          placeholder: "根据以下填写数据自动计算", //默认提示
          name: "zj_total",
          level: "b",
          disabled: true,
          show: false,
          check: false,
          id: 10,
          span: 4,
          count: [11, 12], //计算的变量
          counttype: "+", //计算的类型 + -
        },
        {
          value: undefined,
          label: "一级注册造价工程师(人)",
          name: "zj_one",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 11,
          span: 2,
        },
        {
          value: undefined,
          label: "二级注册造价工程师(人)",
          name: "zj_two",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 12,
          span: 2,
        },
        {
          value: undefined,
          label: "2.注册建筑师(人)",
          placeholder: "根据以下填写数据自动计算", //默认提示
          name: "jzhu_total",
          level: "b",
          disabled: true,
          show: false,
          check: false,
          id: 13,
          span: 4,
          count: [14, 15], //计算的变量
          counttype: "+", //计算的类型 + -
        },
        {
          value: undefined,
          label: "一级注册建筑师(人)",
          name: "jzhu_one",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 14,
          span: 2,
        },
        {
          value: undefined,
          label: "二级注册建筑师(人)",
          name: "jzhu_two",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 15,
          span: 2,
        },
        {
          value: undefined,
          label: "3.注册咨询工程师(人)",
          name: "seek",
          level: "b",
          disabled: false,
          show: true,
          check: false,
          id: 16,
          span: 4,
        },
        {
          value: undefined,
          label: "4.注册建造师(人)",
          placeholder: "根据以下填写数据自动计算", //默认提示
          name: "jzao_total",
          level: "b",
          disabled: true,
          show: false,
          check: false,
          id: 17,
          span: 4,
          count: [18, 19], //计算的变量
          counttype: "+", //计算的类型 + -
        },
        {
          value: undefined,
          label: "一级注册建造师(人)",
          name: "jzao_one",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 18,
          span: 2,
        },
        {
          value: undefined,
          label: "二级注册建造师(人)",
          name: "jzao_two",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 19,
          span: 2,
        },
        {
          value: undefined,
          label: "5.注册监理工程师(人)",
          name: "supervision",
          level: "b",
          disabled: false,
          show: true,
          check: false,
          id: 20,
          span: 4,
        },
        {
          value: undefined,
          label: "6.其他注册执业人员(人)",
          name: "other_zc",
          level: "b",
          disabled: false,
          show: true,
          check: false,
          id: 21,
          span: 4,
        },
      ],
    };
  },
  watch: {
    list: {
      handler(val, oldval) {
        // console.log(val, oldval, '-=-=');
        this.handcount(val, oldval);
      },

      // 深度观察监听
      deep: true,
    },
  },
  computed: {},
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    //获取访问状态
    init() {
      let that = this;
      let data = {};
      that.$http.post("institution/basicqk/getStatus", data).then((res) => {
        if (res.code == 1) {
          if (res.data == 2) {
            for (let i = 0; i < this.list.length; i++) {
              this.list[i]["disabled"] = true;
            }
            this.bc = true;
          }
          this.getinfo();
        }
      });
    },
    //获取列表
    getinfo() {
      let that = this;
      let data = {
        year: this.year ? this.year : "",
      };
      that.$http.post("institution/person/getDetail", data).then((res) => {
        if (res.code == 1) {
          that.info = res.data;
          this.year = this.$route.query.year
            ? this.$route.query.year
            : this.info.year;
          for (const [key, value] of Object.entries(res.data)) {
            for (let i = 0; i < this.list.length; i++) {
              if (this.list[i].name && this.list[i].name == key) {
                this.list[i].value = value == null ? undefined : Number(value);
              }
            }
          }
        }
      });
    },
    //失去焦点改变输入框的状态
    check(item, index) {
      for (let i = 0; i < this.list.length; i++) {
        if (index == i) {
          // console.log(this.list[i].value, '失去焦点')
          if (this.list[i].value == undefined) {
            this.list[i].value = undefined;
            this.list[i]["check"] = true;
          } else {
            this.list[i]["check"] = false;
          }
        }
      }
    },
    //校验动态添加类名
    getClassName(item) {
      // 动态生成类名的逻辑
      if (item) {
        return "check";
      } else {
        return "";
      }
    },
    //计算公式
    handcount(val, oldval) {
      // console.log(val, oldval, '-=-=')
      for (let i = 0; i < val.length; i++) {
        let arr = [];
        if (val[i].count && val[i].count.length > 0) {
          for (let y = 0; y < val[i].count.length; y++) {
            for (let z = 0; z < val.length; z++) {
              if (val[z].id == val[i].count[y]) {
                arr.push(val[z].value);
              }
            }
          }
          const filteredArray = arr.filter(
            (item) => typeof item !== "undefined"
          );
          // console.log(filteredArray)

          if (val[i].counttype == "+") {
            const sum = filteredArray.reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );
            this.list[i].value = sum;
          }
          if (val[i].counttype == "-") {
            const diff = filteredArray.reduce(
              (accumulator, currentValue) => accumulator - currentValue
            );
            this.list[i].value = diff;
          }
        }
      }
    },
    //保存
    Submit() {
      this.loading = true;
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(() => {
        this.loading = false; //之后放到接口
        let valid = true;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].value == undefined && this.list[i].show == true) {
            this.list[i]["check"] = true;
            valid = false;
          } else {
            this.list[i]["check"] = false;
            valid = true;
          }
        }

        // console.log(this.checkimg)

        if (valid) {
          // console.log(this.list)
          let obj = {};
          this.list.forEach((item, index) => {
            obj[item.name] = item.value ? item.value : 0;
          });
          // console.log(JSON.stringify(obj));

          let that = this;
          let data = {
            year: this.year ? this.year : "",
            id: this.info.id,
          };
          data = { ...data, ...obj };
          that.$http.post("institution/person/getEdit", data).then((res) => {
            this.$self.ts(res).then(() => {
              this.init();
            });
          });
        } else {
          console.log("填写完整信息");
        }
        clearTimeout(this.timerId);
      }, 500); // 设置延迟时间，单位为毫秒
    },
  },
};
</script>
<style scoped>
.Financial_box {
  margin: 20px 20px;
}

.title {
  height: 40px;
  background: #1954a4;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-descriptions-item__content {
  padding: 0 !important;
}

::v-deep .el-input-number {
  width: 100%;
  height: 100%;
}

::v-deep .el-input__inner {
  height: 51px;
  border: none;
  text-align: left;
  font-size: 16px;
  color: #333;
}

::v-deep .el-input.is-disabled .el-input__inner {
  color: #333;
  background: #fff;
}

::v-deep .is-bordered-label {
  width: 240px;
  text-align: end !important;

  font-size: 16px;
  font-family: Microsoft YaHei;
  background: #fff;
}

.check ::v-deep .el-input .el-input__inner::placeholder {
  color: #e60013 !important;
}

.check ::v-deep .el-input .el-input__inner {
  color: #e60013 !important;
}

.check {
  position: relative;
}

.checkname {
  position: absolute;
  top: 39%;
  right: 3%;
  color: #e60013;
}

.upload_allbox {
  margin: 20px 0px 0;
  background: #fff;
  border: 1px solid #f2f2f2;
  display: flex;
  align-items: center;
  padding: 30px 0.175rem;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  position: relative;
}

.checkimg {
  position: absolute;
  top: 39%;
  right: 5%;
  color: #e60013;
}

.upload_allbox ::v-deep .el-upload--picture-card {
  width: 71px;
  height: 71px;
  line-height: 80px;
  background: #fafafa;
}

.upload_allbox ::v-deep.el-upload--picture-card i {
  font-size: 22px;
}

.upload_allbox ::v-deep.el-upload-list--picture-card .el-upload-list__item {
  width: 71px;
  height: 71px;
}

.button_box {
  padding: 20px;
  background: #fafafa;
  border: 1px solid #f2f2f2;
}
</style>
<style>
.labelclassa {
  font-weight: bold !important;
  color: #1954a4 !important;
  position: relative;
  padding-right: 20px !important;
  box-sizing: border-box !important;
}

.labelclassb {
  font-weight: bold !important;
  color: #333333 !important;
  position: relative;
  /* padding-right: 29px !important; */
  box-sizing: border-box !important;
}

.labelclassc {
  color: #333333 !important;
  font-weight: 400 !important;
  position: relative;
  /* padding-right: 29px !important; */
  box-sizing: border-box !important;
}
</style>
  